document.addEventListener('DOMContentLoaded', function () {
    const container = document.getElementById('news-archive-menu');
    if (!container) return;

    container.addEventListener('click', function (e) {
        const btn = e.target.closest('.news-menu-item__toggle');
        if (!btn) return;

        const node = btn.closest('.news-menu-item--level-1');
        if (!node) return;

        const submenu = node.querySelector('.news-menu-item__submenu');
        if (!submenu) return;

        const isOpen = node.classList.toggle('news-menu-item--open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        // 👇 добавляем ПЛАВНОСТЬ на max-height без изменений верстки/SCSS
        if (isOpen) {
            // открыть: сначала обнулим, затем поставим реальную высоту
            submenu.style.maxHeight = '0px';            // фикс стартовой точки
            // форс-рефлоу, чтобы браузер «увидел» 0 (иначе может пропустить кадр)
            submenu.offsetHeight;                       // не удалять
            submenu.style.maxHeight = submenu.scrollHeight + 'px';
        } else {
            // закрыть: с текущего scrollHeight уходим в 0
            submenu.style.maxHeight = submenu.scrollHeight + 'px'; // зафиксировать текущую
            submenu.offsetHeight;                                   // форс-рефлоу
            submenu.style.maxHeight = '0px';
        }
    });
});